import constants from './constants.js';
import reduce from 'lodash/reduce';

const initialState = reduce(
	constants.actionsData,
	(accumulator, element) => {
		accumulator[ element.id ] = {
			loading: false,
			error: false,
			value: false
		};
		return accumulator;
	},
	{}
);

export default function manageHttpReducer(state = initialState, action) {
	return action.setState ? action.setState(state) : state;
}



// WEBPACK FOOTER //
// ./src/libraries/reducers/http-request/reducer.js